module.exports = __webpack_public_path__ + "img/circle-three-quarters.284d0bd8.svg";